<!-- <p>visitor-calendar-container works!</p> -->
<div>
  <mat-card class="visitor-calendar-card">
    <mat-card-content class="visitor-calendar-card-content">
      <!-- !calendarState.flows.isCreateNewVisitorFlow -->
      <div *ngIf="!calendarState.flows.isCreateNewVisitorFlow">
        <mat-grid-list
          [cols]="screenSize == ScreenType.Mobile ? 1 : 2"
          gutterSize="20px"
          [rowHeight]="screenSize == ScreenType.Mobile ? '90px' : '100px'"
        >
          <mat-grid-tile
            [rowspan]="
              screenSize == ScreenType.Mobile
                ? 5
                : screenSize == ScreenType.Tablet
                ? 6
                : 7
            "
          >
            <div class="div-inside-grid-tile">
              <app-date-time-picker
                (calendarDimensions)="getCalendarDimensions($event)"
                (dateTimeSlot)="onSelectedDateTimeSlot($event)"
                (addNewVisitor)="onAddNewVisitor($event)"
                (selectedDate)="getSelectedtDateForDetails($event)"
                [screen]="screenSize"
              ></app-date-time-picker>
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            [rowspan]="
              screenSize == ScreenType.Mobile
                ? 5
                : screenSize == ScreenType.Tablet
                ? 6
                : 7
            "
          >
            <div class="div-inside-grid-tile">
              <app-calendar-details
                *ngIf="isCalendarLoaded"
                [calDimensions]="dimension"
                [selectedDate]="dateDetails"
                [visitorData]="dashboardData.visitorDetails.visitorList"
                [chartData]="chartData"
                [screen]="screenSize"
              ></app-calendar-details>
            </div>
          </mat-grid-tile>
        </mat-grid-list>

        <br />
        <mat-divider></mat-divider>
        <br />
      </div>
      <!-- calendarState.flows.isCreateNewVisitorFlow -->
      <div class="row" *ngIf="calendarState.flows.isCreateNewVisitorFlow">
        <div class="col">
          <app-visitor-invite
            [selectedDate]="selectedDate"
            [hostLists]="hostLists"
            [visitorList]="visitorList"
            (onCreateNewVisitor)="createNewVisitorInvite($event)"
            (onUpdateExistingVisitor)="updateExistingVisitor($event)"
            (onCancelVisitorInvite)="cancelVisitorInvite()"
            [screen]="screenSize"
          ></app-visitor-invite>
        </div>
        <br />
        <mat-divider></mat-divider>
        <br />
      </div>

      <div class="row">
        <div class="col">
          <app-expected-visitor
            *ngIf="
              dashboardData.visitorDetails.visitorList.length &&
              !calendarState.flows.isCreateNewVisitorFlow
            "
            [visitorData]="dashboardData.visitorDetails.visitorList"
            [selectedDate]="dateDetails"
            (showVisitorDetail)="onShowVisitorDetail($event)"
            [screen]="screenSize"
          ></app-expected-visitor>
        </div>
      </div>
      <div
        *ngIf="
          isShowVisitorDetail && !calendarState.flows.isCreateNewVisitorFlow
        "
        class="row"
      >
        <div class="col">
          <app-visitor-details
            [visitorDetails]="visitorData"
            (closeVisitorDetail)="onCloseVisitorDetail()"
            [screen]="screenSize"
          ></app-visitor-details>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
<!-- Creating Visitor Invite Dialog Content -->
<ng-template #VisitorInviteDialog>
  <h2 matDialogTitle>Creating Visitor Invite!</h2>
  <mat-dialog-content>
    <mat-spinner></mat-spinner>
  </mat-dialog-content>
</ng-template>
